import { Fragment } from "react";
import styled from "styled-components";
import { PrimaryButton, InputText } from "@loanbossinc/component-library";

export const PaddedDiv = styled.div`
padding: 30px 10px 10px 30px;
`;
export const StyledDialog = styled(Fragment)`
width: 480px;
height: 477px;
`;
export const StyledInputText = styled(InputText)`
width: 50%;
`;
export const StyledPrimaryButton = styled(PrimaryButton)`&&&{
margin-left: 24px;
}`;
export const StyledTitle = styled.div`
color: #005AA9;
font-family: Work Sans;
font-size: 20px;
font-style: normal;
font-weight: 500;
padding-left: 20px;
padding-top: 20px;
width: 100%;
padding-bottom: 16px;
box-shadow: 0px 10px 20px rgb(173 174 174 / 25%);
display: flex;
flex-flow: row;
align-items: center;
justify-content: inherit;
`;
export const FoundUserWrapper = styled.div`
align-items: center;
background: #FFFFFF;
border-radius: 4px;
border: 1px solid #DADCE0;
box-shadow: 0px 10px 20px rgb(173 174 174 / 25%);
box-sizing: border-box;
display: flex;
flex-flow: row;
height: 98px;
margin: auto;
padding-right: 20px;
width: fit-content;
`;
export const FoundUserIcon = styled.div`
 background: #003869;
 border-radius: 100%;
 display: flex;
 height: 48px;
 justify-content: center;
 width: 48px;
 margin: 10px;
`;
export const FoundUserIconInitials = styled.div`
align-items: center;
color: #FFFFFF;
display: flex;
font-family: Work Sans;
font-size: 20px;
font-style: normal;
font-weight: normal;
line-height: 23px;
text-align: center;
`;
export const FoundUserDetails = styled.div`
`;
export const FoundName = styled.div`
font-family: Work Sans;
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 28px;
display: flex;
align-items: center;
width: max-content;
`;
export const FoundCompany = styled.div`
font-family: Work Sans;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;
/* identical to box height */

display: flex;
align-items: center;
width: max-content;
`;
export const FoundEmail = styled.div`
font-family: Work Sans;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 19px;
/* identical to box height */

display: flex;
align-items: center;
width: max-content;
`;
export const FoundItemWrapper = styled.div`
justify-content: center;
display: flex;
flex-direction: column;
`;
export const DialogMessage = styled.div`
margin-bottom: 20px;
font-weight: 600;
`;
export const SingleCompanySelect = styled.div`
display: flex;
flex-flow: column;
max-height: 200px;
align-items: center;
`;
export const MultipleCompanySelect = styled.div`
display: flex;
flex-flow: column;
max-height: 200px;
overflow-y: scroll;
align-items: center;
`;
export const CompanyItem = styled.div`
color: ${props => (props.selectedCompanyId === props.companyId ? "#fff" : "")};
background-color: ${props => (props.selectedCompanyId === props.companyId ? "#3f51b5" : "#FFFFFF")};
border-radius: 4px;
border: 1px solid #DADCE0;
box-shadow: 0px 10px 20px rgb(173 174 174 / 25%);
box-sizing: border-box;
width: 300px;
margin: 2px;
padding: 10px;  
cursor: pointer;
`;

export const ConfirmText = styled.div`
font-family: Work Sans;
font-size: 17px;
font-style: normal;
font-weight: normal;
`;

export const ConfirmValue = styled.div`
font-family: Work Sans;
font-size: 16px;
font-style: normal;
font-weight: 600;
margin-left: 16px;
`;
export const SupportWrapper = styled.div`
align-items: center;
background: #FFFFFF;
border-radius: 4px;
border: 1px solid #DADCE0;
box-sizing: border-box;
display: flex;
height: 60px;
justify-content: center;
margin: auto;
width: 250px;
&:hover {
  background: #f4f4f4;
  cursor:pointer;
} 
`;
